import cn from 'classnames';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const Or = ({ className }: { className: string }) => (
  <div className={cn('flex w-full items-center', className)}>
    <div className="h-px flex-1 bg-gray-700/10" />
    <div className="mx-2 text-sm font-bold text-gray-700">{t`OR`}</div>
    <div className="h-px flex-1 bg-gray-700/10" />
  </div>
);

export default Or;
